<template>
  <div>
    <!-- Header -->
    <header
      v-if="variants.v1 === variant "
      :class="[
        'header',
        'rochford-header',
        {
          'is-transparent': !menuVisible && !isScrolled,
          'is-white': menuVisible || isScrolled,
          'is-hidden': isPopupOpen,
        },
      ]"
    >
      <div class="header__container">
        <!-- Sol - Menü Butonu -->
        <div class="header__left">
          <button class="menu-toggle" @click="toggleMenu">
            <span class="menu-icon" :class="{ 'is-active': menuVisible }">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
        
        <!-- Orta - Logo -->
        <div class="header__center">
          <nuxt-link :to="homeLink" class="header__logo" :external="true">
            <img :src="logo" alt="logo" class="logo-image" />
          </nuxt-link>
        </div>
        
        <!-- Sağ - Butonlar -->
        <div class="header__right">
          <div class="header__buttons">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[
                'header__button',
                button.button_type === 'primary' ? 'btn-primary' : 'btn-outline',
              ]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </header>

    <!-- Menü -->
    <div
      v-if="variants.v1 === variant&& menuVisible"
      class="rochford-menu"
      :class="{ 
        'is-open': menuVisible,
        'has-submenu-open': openSubMenu !== null
      }"
    >
      <!-- Sol %25 - Ana Menüler -->
      <div class="menu__section menu__section--primary">
        <div class="menu__nav">
          <div
            v-for="(menuItem, itemIndex) in columnOneMenu"
            :key="`menuItem-${itemIndex}`"
            class="menu__item"
            :class="{
              'has-submenu': menuItem.has_sub_menu,
              'is-active': openSubMenu === itemIndex
            }"
          >
            <a
              href="javascript:void(0)"
              class="menu__link"
              @click="menuItem.has_sub_menu
                ? toggleSubMenu(itemIndex)
                : handleMenuLinkClick(menuItem)"
            >
              <h3>{{ menuItem.name }}</h3>

              <!-- submenu varsa ok ikonunu göster -->
              <span v-if="menuItem.has_sub_menu" class="submenu-icon">
                <svg
                  width="44" height="44"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  :class="{ 'is-open': openSubMenu === itemIndex }"
                >
                  <circle
                    cx="25" cy="25" r="24.5"
                    transform="matrix(0 -1 -1 0 50 50)"
                    :stroke="openSubMenu === itemIndex ? '#000' : '#EEEEEE'"
                  />
                  <path
                    d="M33.3536 25.3536C33.5488 25.1583 33.5488 24.8417 33.3536 24.6464L30.1716 21.4645C29.9763 21.2692 29.6597 21.2692 29.4645 21.4645C29.2692 21.6597 29.2692 21.9763 29.4645 22.1716L32.2929 25L29.4645 27.8284C29.2692 28.0237 29.2692 28.3403 29.4645 28.5355C29.6597 28.7308 29.9763 28.7308 30.1716 28.5355L33.3536 25.3536ZM18 25.5H33V24.5H18V25.5Z"
                    fill="#171717"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
        
        <!-- Mobilde Butonlar -->
        <div class="mobile-buttons">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`mobile-button-${index}`"
            :class="[
              'mobile-button',
              button.button_type === 'primary' ? 'btn-primary' : 'btn-outline',
            ]"
            :to="button.button_link || '/'"
            :external="true"
            @click="toggleMenu"
          >
            {{ button.button_label }}
          </nuxt-link>
        </div>
      </div>
      
      <!-- Orta %25 - Alt Menüler -->
      <div class="menu__section menu__section--submenu">
        <!-- Mobil Geri Butonu -->
        <button class="mobile-back-btn" @click="closeSubMenu">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="15.5" transform="rotate(-90 16 16)" stroke="#EEEEEE"/>
<path d="M8.64645 16.3536C8.45118 16.1583 8.45118 15.8417 8.64645 15.6464L11.8284 12.4645C12.0237 12.2692 12.3403 12.2692 12.5355 12.4645C12.7308 12.6597 12.7308 12.9763 12.5355 13.1716L9.70711 16L12.5355 18.8284C12.7308 19.0237 12.7308 19.3403 12.5355 19.5355C12.3403 19.7308 12.0237 19.7308 11.8284 19.5355L8.64645 16.3536ZM24 16.5H9V15.5H24V16.5Z" fill="#171717"/>
</svg>

          
        </button>
        
        <div
          v-for="(menuItem, itemIndex) in columnOneMenu"
          :key="`submenu-${itemIndex}`"
          v-show="openSubMenu === itemIndex && menuItem.has_sub_menu"
          class="submenu__container"
        >
          <div
            v-for="(subMenu, sIndex) in menuItem.sub_menus"
            :key="`subMenu-${itemIndex}-${sIndex}`"
            class="submenu__item"
          >
            <nuxt-link
              :to="subMenu.url || '/'"
              :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
              :external="true"
              @click="toggleMenu"
              class="submenu__link"
            >
              <h4>{{ subMenu.name }}</h4>
            </nuxt-link>
          </div>
        </div>
      </div>
      
      <!-- Sağ %50 - Boş ve Saydam Alan -->
      <div 
        class="menu__section menu__section--empty"
        @click="toggleMenu"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { MenuTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

export default defineNuxtComponent({
  name: 'RochfordHeaderComponent',
  mixins: [ComponentMixin],
  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
      isPopupOpen: false,
      variants: { v1: 'v1' },
      scrollThreshold: 50,
    };
  },
  computed: {
    buttons() {
      return this.groupedVariables.buttons || [];
    },
    ...mapState(useWebsiteStore, ['headerMenuItems', 'company']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),
    homeLink(): string {
      return '/';
    },
    logo(): string {
      const currentCompany = this.company as any;
      return currentCompany?.logo || '';
    },
    columnOneMenu(): MenuItem[] {
      const content = this.component?.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return (this.headerMenuItems as MenuItem[]) || [];
      }
      return [];
    },
  },
  methods: {
    toggleMenu(): void {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
        this.openSubMenu = null;
      }
    },
    toggleSubMenu(index: number): void {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },
    closeSubMenu(): void {
      this.openSubMenu = null;
    },
    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: menuItem.is_open_new_tab || false,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
      this.toggleMenu();
    },
    handleScroll(): void {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },
    checkPopupOpen(): void {
      this.isPopupOpen = document.body.classList.contains('popup-open');
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    this.checkPopupOpen();
    const observer = new MutationObserver(() => this.checkPopupOpen());
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.$data.popupObserver = observer;
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
    this.$data.popupObserver?.disconnect();
  },
});
</script>

<style lang="scss" scoped>
// Header Styles
.rochford-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  z-index: 1000;
  transition: all 0.3s ease;

  @supports not (position: sticky) {
    position: fixed;
    top: 0;
  }

  &.is-transparent {
    background-color: transparent;

    .header__button {
      color: #fff;
      border-color: #fff;

      &:hover {
        background-color: #fff;
        color: #000;
      }
    }

    .menu-icon span {
      background-color: #000;
    }
  }

  &.is-white {
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .header__button {
      color: #000;
      border-color: #000;

      &:hover {
        background-color: #000;
        color: #fff;
      }
    }

    .menu-icon span {
      background-color: #000;
    }
  }

  &.is-hidden {
    transform: translateY(-100%);
  }

  .header__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 40px;
    max-width: 1440px;
    margin: 0 auto;
  }

  .header__left,
  .header__right {
    flex: 1;
  }

  .header__center {
    flex: 0 0 auto;
  }

  .header__right {
    display: flex;
    justify-content: flex-end;
  }

  .header__logo {
    display: inline-block;

    .logo-image {
      height: 60px;
      width: auto;
    }
  }

  .header__buttons {
    display: flex;
    gap: 20px;
  }

  .header__button {
    padding: 14px 30px;
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    border: 1px solid;
    transition: all 0.3s ease;

    &.btn-primary {
      background-color: #E60000;
      color: #fff;
      border-color: #E60000;

      &:hover {
        background-color: #c00000;
        border-color: #c00000;
      }
    }

    &.btn-outline {
      background-color: transparent;
      border: 1px solid;
    }
  }
}

// Menü Toggle Button
.menu-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 14px;
  display: flex;
  align-items: left;
  justify-content: left;

  .menu-icon {
    display: block;
    width: 30px;
    height: 22px;
    position: relative;

    span {
      display: block;
      width: 100%;
      height: 2px;
      background-color: #000;
      position: absolute;
      left: 0;
      transition: all 0.3s ease;

      &:first-child {
        top: 0;
      }

      &:nth-child(2) {
        top: 50%;
        transform: translateY(-50%);
      }

      &:last-child {
        bottom: 0;
      }
    }

    &.is-active {
      span {
        &:first-child {
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:last-child {
          bottom: 50%;
          transform: translateY(50%) rotate(-45deg);
        }
      }
    }
  }
}

// Menü Styles
.rochford-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
  display: flex;
  transform: translateX(-100%);
  transition: transform 0.4s ease;

  &.is-open {
    transform: translateX(0);
  }

  .menu__section {
    height: 100%;
    padding-top: 140px;
    transition: all 0.3s ease;

    &--primary {
      width: 25%;
      background-color: #fff;
      padding-left: 40px;
      padding-right: 20px;
    }

    &--submenu {
      width: 0;
      background-color: #f8f8f8;
      padding: 140px 0 0 0;
      border-right: 1px solid #e5e5e5;
      overflow: hidden;
      opacity: 0;
      transition: width 0.3s ease, opacity 0.3s ease, padding 0.3s ease;

      .mobile-back-btn {
        display: none;
      }
    }

    &--empty {
      flex: 1;
      background-color: transparent;
      cursor: pointer;
    }
  }

  &.has-submenu-open {
    .menu__section--submenu {
      width: 25%;
      padding: 140px 40px 0 40px;
      opacity: 1;
    }
  }

  .menu__nav {
    .menu__item {
      
      

      &.is-active .menu__link {
        color: #E60000;
      }
    }

    .menu__link {
      font-size: 18px;
      font-weight: 500;
      color: #000;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      transition: color 0.3s ease;

      &:hover {
        color: #E60000;
      }

      h3 {
        margin: 0;
        font-size: inherit;
        font-weight: inherit;
      }
    }

    .submenu-icon {
      display: inline-block;
      margin-left: 8px;

      svg {
        transition: transform 0.3s ease;
        transform: rotate(0deg);
      }

      svg.is-open {
        transform: rotate(180deg);
      }
    }
  }

  .mobile-buttons {
    display: none;
    margin-top: 40px;
    padding-top: 40px;
    border-top: 1px solid #e5e5e5;
    flex-direction: column;
    gap: 20px;

    .mobile-button {
      display: block;
      padding: 14px 30px;
      font-size: 18px;
      font-weight: 500;
      text-transform: uppercase;
      text-decoration: none;
      text-align: center;
      border: 1px solid;
      transition: all 0.3s ease;

      &.btn-primary {
        background-color: #E60000;
        color: #fff;
        border-color: #E60000;

        &:hover {
          background-color: #c00000;
          border-color: #c00000;
        }
      }

      &.btn-outline {
        background-color: transparent;
        color: #000;
        border-color: #000;

        &:hover {
          background-color: #000;
          color: #fff;
        }
      }
    }
  }

  .submenu__container {
    

    .submenu__link {
      font-size: 14px;
      color: #666;
      text-decoration: none;
      display: inline-block;
      transition: color 0.3s ease;

      &:hover {
        color: #E60000;
      }

      h4 {
        margin: 0;
        font-size: inherit;
        font-weight: inherit;
      }
    }
  }
}

// No scroll when menu is open
:global(.no-scroll) {
  overflow: hidden;
}

// Responsive
@media (max-width: 1024px) {
  .rochford-header {
    height: 80px;

    .header__container {
      padding: 0 20px;
    }

    .header__buttons {
      display: none;
    }

    .header__logo .logo-image {
      height: 40px;
    }
  }

  .rochford-menu {
    .menu__section {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-top: 100px;
      transition: transform 0.3s ease;

      &--primary {
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 40px;
        transform: translateX(0);
        overflow-y: auto;

        .mobile-buttons {
          display: flex;
        }
      }

      &--submenu {
        width: 100%;
        background-color: #fff;
        border-right: none;
        transform: translateX(100%);
        opacity: 1;
        padding: 100px 20px 40px 20px;
        overflow-y: auto;

        .mobile-back-btn {
          display: flex;
          align-items: center;
         
          background: none;
          border: none;
          padding: 0;
         
          font-size: 16px;
          color: #666;
          cursor: pointer;

          &:hover {
            color: #000;
          }
        }
      }

      &--empty {
        display: none;
      }
    }

    &.has-submenu-open {
      .menu__section--primary {
        transform: translateX(-100%);
      }

      .menu__section--submenu {
        transform: translateX(0);
        width: 100% !important;
        padding: 100px 20px 40px 20px !important;
      }
    }
  }
}
</style>
